module.exports = __webpack_public_path__ + "img/galaxy_purple.5986f293.png";